angular.module('picmonicng').directive('twitterFeed', function () {
  return {
    restrict: 'E',
    link: function (scope, element) {
      scope.$on('$viewContentLoaded', function () {
        !(function (d, s, id) {
          var js,
            fjs = element[0],
            p = /^http:/.test(d.location) ? 'http' : 'https';
          js = d.createElement(s);
          js.id = id;
          js.src = p + '://platform.twitter.com/widgets.js';
          fjs.parentNode.insertBefore(js, fjs);
        })(document, 'script', 'twitter-wjs');
      });
    },
  };
});
